import { getDoc as getDocSdk, getDocFromServer as getDocFromServerSdk, getDocs as getDocsSdk, onSnapshot as onSnapshotSdk } from 'firebase/firestore';
import { leerDocumento } from './legacyData';

// Frontera de lectura, sin queries adicionales ni cambios de autorización.
// Conserva los snapshots/ref SDK; únicamente adapta data() de colecciones conocidas.
function documento(snap, ref = snap.ref) {
  const coleccion = ref?.parent?.id;
  if (!coleccion) return snap;
  return new Proxy(snap, { get(target, key) {
    if (key === 'data') return (...args) => leerDocumento(coleccion, target.data(...args), target.id);
    const value = Reflect.get(target, key);
    return typeof value === 'function' ? value.bind(target) : value;
  } });
}
export async function getDoc(ref, ...args) { return documento(await getDocSdk(ref, ...args), ref); }
export async function getDocFromServer(ref, ...args) { return documento(await getDocFromServerSdk(ref, ...args), ref); }
export async function getDocs(...args) {
  const snap = await getDocsSdk(...args);
  return consulta(snap);
}
function consulta(snap) {
  const docs = snap.docs.map((d) => documento(d));
  return new Proxy(snap, { get(target, key) {
    if (key === 'docs') return docs;
    if (key === 'forEach') return (callback, thisArg) => docs.forEach(callback, thisArg);
    const value = Reflect.get(target, key);
    return typeof value === 'function' ? value.bind(target) : value;
  } });
}
export function onSnapshot(ref, ...args) {
  const adaptar = (snap) => Array.isArray(snap.docs) ? consulta(snap) : documento(snap, ref);
  const index = args.findIndex((arg) => typeof arg === 'function' || (arg && typeof arg.next === 'function'));
  if (index >= 0) {
    const callback = args[index];
    args[index] = typeof callback === 'function' ? (snap) => callback(adaptar(snap))
      : { ...callback, next: (snap) => callback.next(adaptar(snap)) };
  }
  return onSnapshotSdk(ref, ...args);
}
